import React from 'react';
import { PostDrawer, type PostDrawerProps } from './PostDrawer';

/**
 * Compatibility wrapper (dashboard Scheduler, video list): the old "Posting ke
 * media sosial" modal is now the video studio's 3-step Post drawer. Same props
 * as before; the drawer mounts fresh every time it opens.
 */
export const ScheduleDialog: React.FC<PostDrawerProps & { open: boolean }> = ({ open, ...rest }) => (open ? <PostDrawer {...rest} /> : null);
